import Head from "next/head";
import { useRouter } from "next/router";
import { candidateRoute, getFirstRouteSegment } from "../common/userfuctions";

export default function BreadCrumbSchema() {
    const router = useRouter();
    const rt = getFirstRouteSegment(router.pathname);
    const isShowBread = rt ? candidateRoute(rt) : true;
    if (!isShowBread) { return null }
    const asPath = router.asPath?.split('/').filter(item => item != "");
    const path = router.pathname?.split('/').map(str => str.replace(/\[|\]/g, '')).filter(item => item != "");
    const CapatalizeLetter = (str) => str.charAt(0).toUpperCase() + str.slice(1)
    let relativeRoute = 'https://hireside.com/'
    let route = [["Home", relativeRoute]]

    path?.map((item, index) => {
        relativeRoute = relativeRoute + "/" + asPath[index]  // Optional chaining not necessarily helpful here as asPath and index should be defined if path is defined.
        route.push([CapatalizeLetter(item), relativeRoute])
    })

    const itemListElement = route?.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item[0],
        "item": item[1]
    }))

    let schemaData = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": itemListElement
    }

    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
            />
        </Head>
    );
}
